import { Container, EmptyState } from './SavedSearchPage.styled'
import { Layout } from 'layouts/Layout'
import { StyledStickyHeaderPage } from 'modules/VehicleList'
import { VehicleStickyBar } from 'modules/VehicleList/VehicleStickyBar'
import { OverlayLoader } from 'components/Loader'
import { SavedSearchContext, SavedSearchProvider } from '../modules/SavedSearch/SavedSearchContext'
import SavedSearchCard from '../modules/SavedSearch/SavedSearchCard'
import { useGlobalStore } from 'store/useGlobalStore'
import { BUY_VEHICLE_NO_ACTIVITY } from 'common/constants'
import { useContext } from 'react'

const SavedSearchPageContent = () => {
  const { savedSearchesData, loading, saving } = useContext(SavedSearchContext)
  const { getLocalText } = useGlobalStore((state) => state)

  const searches = savedSearchesData || []
  const searchCount = searches?.length

  return (
    <>
      {(loading || saving) && <OverlayLoader />}
      <Layout title="Saved Search">
        <StyledStickyHeaderPage>
          <VehicleStickyBar sectionTitle={`My Saved Searches (${searchCount})`} displayCollapse={false} />
        </StyledStickyHeaderPage>
        <Container>
          {searchCount === 0 && !loading ? (
            <EmptyState>{getLocalText('NO_SEARCH_FOUND_BODY', BUY_VEHICLE_NO_ACTIVITY.SAVE_SEARCH)}</EmptyState>
          ) : (
            searches.map((search) => <SavedSearchCard key={search.ID} search={search} />)
          )}
        </Container>
      </Layout>
    </>
  )
}

export const SavedSearchPage = () => {
  return (
    <SavedSearchProvider>
      <SavedSearchPageContent />
    </SavedSearchProvider>
  )
}

export default SavedSearchPage
